import React from 'react';
import { Image, Col } from 'react-bootstrap';

import './langLegalNamingComponent.scss'

class LangLegalNamingComponent extends React.Component {
    render() {
        return <div className="langlegal-component">
            <br />
            <div className="section">
                <h3>LIFE FITNESS TONE</h3>
                <p>Life Fitness is about encouragement, vitality and empowering people to take the steps needed to transform their health and their lives. We don't shout exercise and we don't promise overnight success. Life Fitness is supportive and our fitness equipment is approachable and inviting.</p>
            </div>

            <br />
            <div className="section">
                <h3>HOW TO USE LIFE FITNESS TRADEMARKS</h3>
                <p>Please show the correct Life Fitness trademarks on printed and digital materials (first reference only). Also, note the following applicable trademark usage somewhere in copy:</p>
                <ul>
                    <li>"This app has been developed in cooperation with Life Fitness."</li>
                    <p><b>(Note: Please do not reference "partnership", "collaberation", or similar agreement.)</b></p>
                    <li>"Discover, Integrity and LFconnect are trademarks of Life Fitness."</li>
                </ul>
            </div>

            <br />
            <div className="section">
                <h3>PRODUCT NAMING</h3>
                <p>The Life Fitness open API allows for developers to create digital tools that are compatible with Life Fitness cardio consoles. These consoles msut be mentioned specifically and with the correct trademark user.</p>
                <ul className="product-naming-list">
                    <li><b>Discover™ SE3 Console </b></li>
                    <li><b>Discover™ SE3 HD Console </b></li>
                    <li><b>Discover™ SI Console </b></li>
                    <li><b>Integrity™ X Console </b></li>
                    <li><b>Integrity™ C Console </b></li>
                </ul>
                <p>Life Fitness names its cardio series separately from the consoles. Referencing the cardio series is not necessary, but the cardio equipment should never be referred to by console and equipment type:</p>

                <ul className="product-naming-list">
                    <li><b>Correct full name: </b> Elevation™ Series Treadmill with Discover™ SE3 Console</li>
                    <li><b>Correct abbreviated name: </b>Treadmill with Discover™ SE3 Console</li>
                    <li><b>Incorrect: </b><i className="red-text">Discover™ Treadmill, Integrity™ X Treadmill</i></li>
                </ul>
            </div>

            <div className="row">
                <h3>IN COOPERATION WITH LIFE FITNESS</h3>
                <ul>
                    <li>When representing working with Life Fitness, the approved phrasing is "Developed in cooperation with Life Fitness".</li>
                    <li>Please do not reference "partnership", "collaboration", or similar agreement.</li>
                    <li>The Life Fitness logo may never be used in place of the words "Life Fitness" in a sentence. Please see acceptable usage below.</li>
                    <li>Acceptable fonts: Avenir Next, Helvetica or Arial</li>
                </ul>
                <Col xs={6} md={6} align="center">
                    <p>Developed in partnership with</p>
                    <Image src={require('../../../../images/incorrect-reference-logo.png')} />
                    <p>INCORRECT</p>
                </Col>
                <div className="in-cooperationwith-row">
                    <Col xs={6} md={4} align="center">
                        <p>Developed in cooperation with Life Fitness.</p>
                        <p>CORRECT</p>
                    </Col>
                </div>
            </div>
        </div>
    }
}

export default LangLegalNamingComponent



// WEBPACK FOOTER //
// ./src/components/marketingGuidelines/marketingComponents/LangLegalNaming/LangLegalNamingComponent.js